<template>
  <spr-dialog name="point" :show="show" :title="title" @confirm="handleConfirm" @open="handleOpen" @update:show="(flag) => this.$emit('update:show', flag)">
    <el-form ref="form" :model="Form" label-suffix="：" label-width="100px" style="margin-left: 50px;" :rules="Rules">
      <el-form-item label="网点编号" prop="Code">
        <el-input v-model="Form.Code" style="width: 280px;" placeholder="请输入网点编号"></el-input>
      </el-form-item>
      <el-form-item label="服务银行" prop="PosServiceBank">
        <!-- <el-input v-model="Form.PosServiceBank" style="width: 280px;" placeholder=""></el-input> -->
        <el-select v-model="Form.PosServiceBank" style="width: 280px;" filterable placeholder="服务银行">
          <el-option v-for="Bank in Banks" :key="Bank.Name" :label="Bank.Name" :value="Bank.Name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="网点类型" prop="PosType">
        <el-select v-model="Form.PosType" style="width: 280px;" placeholder="在行无人银行/离行无人银行/网点营业厅">
          <el-option label="在行无人银行" :value="1"></el-option>
          <el-option label="离行无人银行" :value="2"></el-option>
          <el-option label="网点营业厅" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备类型" prop="PosDeviceType">
        <el-select v-model="Form.PosDeviceType" style="width: 280px;" placeholder="现金自助设备/非现金自助设备">
          <el-option label="现金自助设备" :value="1"></el-option>
          <el-option label="非现金自助设备" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="网点地址" prop="Street">
        <spr-address
          :province-id.sync="Form.ProvinceId"
          :city-id.sync="Form.CityId"
          :county-id.sync="Form.CountyId"
          :address.sync="Form.Street"
        ></spr-address>
      </el-form-item>
      <el-form-item label="网点联系人" prop="PosFirstContactName">
        <el-input v-model="Form.PosFirstContactName" style="width: 280px;" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="网点联系电话" prop="PosFirstContactPhone">
        <el-input v-model="Form.PosFirstContactPhone" style="width: 280px;" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="押钞公司联系人" prop="PosSecondContactName">
        <el-input v-model="Form.PosSecondContactName" style="width: 280px;" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="押钞公司联系电话" prop="PosSecondContactPhone">
        <el-input v-model="Form.PosSecondContactPhone" style="width: 280px;" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="ATM机" prop="PosAtmListJson">
        <el-tag
          class="atmcode"
          v-for="(AtmCode, index) in Form.PosAtmListJson"
          :key="index"
          :closable="true"
          :close-transition="false"
          @close="handleCloseAtmCode(index)"
        >{{AtmCode}}</el-tag>
        <el-input
          class="atmcode-input"
          v-if="AtmInputVisible"
          v-model="AtmInputValue"
          ref="AtmInput"
          @keyup.enter.native="handleAtmInputConfirm"
          @blur="handleAtmInputConfirm"
        ></el-input>
        <el-button v-else class="atmcode-button" @click="showInput">+ ATM机机器编码</el-button>
      </el-form-item>
    </el-form>
  </spr-dialog>
</template>

<script>
import SprDialog from './Dialog'
import SprAddress from '@/components/common/Address'
import _ from 'lodash'
export default {
  data() {
    const listValidator = (rule, value, cb) => {
      console.log(value)
      if (value && value.length > 0) {
        cb()
      } else {
        cb(new Error('该字段必填'))
      }
    }
    return {
      Form: {},
      Rules: {
        PosServiceBank: [{required: true, message: '该字段必填', trigger: 'blur'}],
        PosFirstContactName: [{required: true, message: '该字段必填', trigger: 'blur'}],
        PosFirstContactPhone: [{required: true, message: '该字段必填', trigger: 'blur'}],
        Code: [{ required: true, message: '该字段必填', trigger: 'blur' }],
        PosType: [{ type: 'number', required: true, message: '该字段必填', trigger: 'blur' }],
        PosDeviceType: [{ type: 'number', required: true, message: '该字段必填', trigger: 'blur' }],
        Street: [{ required: true, message: '该字段必填', trigger: 'blur' }],
        PosAtmListJson: [{ validator: listValidator, required: true, message: '该字段必填', trigger: 'blur' }],
      },
      AtmInputVisible: false,
      AtmInputValue: '',
    }
  },
  props: {
    form: null,
    show: Boolean,
    title: String,
    Banks: [],
  },
  methods: {
    handleConfirm() {
      this.Form.Name = this.Form.ProvinceId + this.Form.CityId + this.Form.CountyId + this.Form.Street
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('confirm', _.pick(this.Form, [
            'Id',
            'Name',
            'Code',
            'PosType',
            'PosServiceBank',
            'PosDeviceType',
            'ProvinceId',
            'CityId',
            'CountyId',
            'Street',
            'PosAtmListJson',
            'IsPointOfSale',
            'PosFirstContactName',
            'PosFirstContactPhone',
            'PosSecondContactName',
            'PosSecondContactPhone',
          ]))
        }
      })
    },
    handleOpen() {
      let baseForm = {
        Name: null,
        Code: null,
        PosType: null,
        PosServiceBank: null,
        PosDeviceType: null,
        ProvinceId: null,
        CityId: null,
        CountyId: null,
        Street: null,
        PosAtmListJson: [],
        IsPointOfSale: true,
        PosFirstContactName: null,
        PosFirstContactPhone: null,
        PosSecondContactName: null,
        PosSecondContactPhone: null,
      }
      if (this.form.Id) {
        console.log(this.form)
        baseForm = _.pick(this.form, [
          'Id',
          'Name',
          'Code',
          'PosType',
          'PosServiceBank',
          'PosDeviceType',
          'ProvinceId',
          'CityId',
          'CountyId',
          'Street',
          'PosAtmListJson',
          'IsPointOfSale',
          'PosFirstContactName',
          'PosFirstContactPhone',
          'PosSecondContactName',
          'PosSecondContactPhone',
        ])
        // if (baseForm.PosAtmListJson) {
        //   baseForm.PosAtmListJson = JSON.parse(baseForm.PosAtmListJson)
        // } else {
        //   baseForm.PosAtmListJson = []
        // }
      }
      this.$set(this, 'Form', baseForm)
    },
    showInput() {
      this.AtmInputVisible = true
      this.$nextTick(_ => {
        this.$refs.AtmInput.$refs.input.focus()
      })
    },
    handleAtmInputConfirm() {
      const input = this.AtmInputValue
      if (input) {
        // 检查机器编码是否重复
        for (let i = 0; i < this.Form.PosAtmListJson.length; i++) {
          if (this.Form.PosAtmListJson[i] === input) {
            this.AtmInputVisible = false
            this.AtmInputValue = ''
            return this.$message.error('ATM机机器编码重复!')
          }
        }
        this.Form.PosAtmListJson.push(input)
      }
      this.AtmInputVisible = false
      this.AtmInputValue = ''
    },
    handleCloseAtmCode(index) {
      this.Form.PosAtmListJson.splice(index, 1)
    },
  },
  components: { SprDialog, SprAddress },
}
</script>

<style lang="less" scoped>
.atmcode-input {
  width: 145px;
}
.atmcode {
  // min-width: 145px;
  height: 36px;
  line-height: 36px;
  background: #9b9b9b;
  margin-right: 10px;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// PointDialog.vue?1b14978e